import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import cx from 'classnames'

import ShoppingCartProduct from './ShoppingCartProduct'
import { api } from '../../../../api/integrationAPI'
import { isSafari } from '../../../shared/utils'
import { sendEvent } from '../../../shared/analytics'

import './ShoppingCart.scss'

export default class ShoppingCart extends React.Component {

  constructor (props) {
    super(props)
    this.state = { checkoutUrl: null }
    this.isSafari = isSafari()
  }

  onDelete = (productId) => {
    api.deleteFromCart(productId)
  }

  onBack = () => {
    if (this.state.checkoutUrl) {
      this.setState({ checkoutUrl: null })
    } else {
      this.props.onClose()
    }
  }

  onCheckout = () => {
    const { cart, prodMode } = this.props
    if (cart && cart.checkoutUrl) {
      if (prodMode) sendEvent('Purchase', 'Start')
      if (this.isSafari) {
        window.open(cart.checkoutUrl, '_self')
      } else {
        api.deleteCartHistory()
        this.setState({ checkoutUrl: cart.checkoutUrl })
      }
    }
  }

  renderCheckoutPage () {
    const { isVisible } = this.props
    if (isVisible && !this.isSafari && this.state.checkoutUrl) {
      return (
        <div className='in_cart__checkout' key='iframe'>
          <iframe
            src={this.state.checkoutUrl}
            ref={ref => (this.iframe = ref)}
            className='in_cart__checkout-iframe'
          />
        </div>
      )
    }
  }

  render () {
    // console.log('ShoppingCart render')
    const { cart, isVisible } = this.props
    const products = (cart) ? cart.products : []
    const subtotal = (cart) ? cart.subtotal : 0
    const shouldContentBeScrolled = products.length > 2
    return (
      <CSSTransitionGroup
        transitionName='in_cart'
        transitionEnterTimeout={350}
        transitionLeaveTimeout={250}
      >
        {isVisible && <div className={'in_cart'} key='cart'>
          <div className={'in_cart__back-button'} onClick={this.onBack} />
          <div className={'in_cart__title'}>Shopping Cart</div>
          <div className={'in_cart__content js-scroll'}>
            <div className={'in_cart__products'}>
              {/* we can't use product.id as key because they are not unique */}
              {/* we also can't use array index as key because when item is deleted, there are problems */}
              {products.map((product, i) =>
                <ShoppingCartProduct
                  key={i}
                  title={product.title}
                  price={product.price}
                  image={product.image}
                  variant={product.variant}
                  productId={product.id}
                  onDelete={this.onDelete}
                  enableScroll={shouldContentBeScrolled}
                />
              )}
            </div>
            <table className={'in_cart__table'}>
              <tbody>
                {/* <tr><td>Ground Shipping Standard</td><td>Free</td></tr> */}
                {/* <tr><td>Sales Tax</td><td>$2.00</td></tr> */}
                <tr><td><b>Subtotal</b></td><td>{subtotal}</td></tr>
              </tbody>
            </table>
            <div className={'in_cart__buttons'}>
              <button className={'in_cart__button in_cart__button--muted'} onClick={this.props.onClose}>
                Continue Shopping
              </button>
              <button
                className={cx('in_cart__button', this.state.checkoutUrl && 'in_cart__button--muted')}
                onClick={this.onCheckout}
              >
                Checkout
              </button>
            </div>
          </div>
        </div>}
        {this.renderCheckoutPage()}
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    onClose: PropTypes.func,
    cart: PropTypes.object,
    isVisible: PropTypes.bool,
    prodMode: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/components/cart/ShoppingCart.js